/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_Cap_BodyInputs */



/**
* | output |
* | --- |
* | "This recording has been running for three hours. If you say nothing, Wundo closes it shortly and writes the report." |
*
* @param {Meeting_Offline_Cap_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_cap_body = /** @type {((inputs?: Meeting_Offline_Cap_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Cap_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Deze opname loopt al drie uur. Zeg je niets, dan sluit Wundo ze zo af en maakt ze het verslag.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cet enregistrement tourne depuis trois heures. Si vous ne réagissez pas, Wundo le clôture bientôt et rédige le compte rendu.")
	return /** @type {LocalizedString} */ ("This recording has been running for three hours. If you say nothing, Wundo closes it shortly and writes the report.")
});